import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Data, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';

import { debounceTime, takeUntil } from 'rxjs/operators';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { Project, ProjectPagination, Image, Pipeline, Appointment, Comment } from 'app/modules/projects/projects.types';
import {
  Account,
  ProjectType,
  PropertyType,
  ProjectStage,
  FieldDef,
  InvestmentType,
  Vehicle,
} from 'app/core/models/account.types';
import { User } from 'app/core/models/user.types';
import { AccountService } from 'app/core';

@Component({
  selector: 'projects-filter-save',
  templateUrl: './projects-filter-save.component.html',
  styleUrls: ['./projects-filter-save.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectsFilterSaveComponent implements OnInit {
  saveFilterForm: UntypedFormGroup;

  projectTypes: ProjectType[];
  propertyTypes: PropertyType[];
  projectStages: ProjectStage[];
  vehicles: Vehicle[];
  investmentTypes: InvestmentType[];
  users: User[];

  filters: any;

  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {MatDialogRef} matDialogRef
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectsFilterSaveComponent>,
    private _formBuilder: UntypedFormBuilder,
    private _changeDetectorRef: ChangeDetectorRef,
    private _accountService: AccountService,
    private _activatedRoute: ActivatedRoute,
  ) {
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.saveFilterForm = this._formBuilder.group({
      name: ['', Validators.required],
    });

    if (this.data.filters) {
      this.filters = this.data.filters;
    }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  setAddress(addressString) {
    //this.projectForm.get('deal').get('property').get('address').get('address_string').setValue(addressString);
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Send the message
   */
  save(): void {
    let savedFilter = this.saveFilterForm.value;
    savedFilter.filters = JSON.stringify(this.filters);

    //project.pipeline_id = this._projectsService.pipelineId;
    this._accountService.saveFilter(savedFilter).subscribe((savedFilter) => {
      this.matDialogRef.close();
    });
  }
}
